// The product name in one place, so it is easy to change before going public.
export const APP_NAME = 'Closetly';
